
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'

@Component({
  components: {
    portal: () =>
      import(
        /* webpackChunkName: "vue-portal", webpackMode: "lazy" */ 'portal-vue'
      ).then(({ Portal }) => Portal),
  },
})
export default class PuModal extends Vue {
  @Prop({ default: false })
    showModal: boolean

  showModalState = false

  @Prop({ default: true })
    showTrigger: boolean

  @Prop({ type: Boolean, default: false })
    usePortal: boolean

  @Prop({ default: 'portal-target', required: false })
    portalTarget: string

  @Prop({ required: false })
    modalClass?: string

  @Prop({ required: true })
    modalHash: string

  mounted() {
    const routeHash = this.$route.hash
    const hashes = routeHash.substring(1).split('&')
    if (routeHash !== '' && hashes.includes(this.modalHash)) {
      this.setModalStateOpen()
    }
  }

  setModalStateOpen() {
    this.showModalState = true
    this.$emit('change-show-modal-state', true)
  }

  setModalStateClosed() {
    this.showModalState = false
    this.$emit('change-show-modal-state', false)
  }

  @Watch('showModal')
  changeBodyAttribute(newValue: boolean) {
    newValue
      ? document.body.setAttribute('data-noscroll', 'true')
      : document.body.removeAttribute('data-noscroll')
  }

  @Watch('$route')
  routeChange(to: Route, from?: Route) {
    if (to.path === from?.path) {
      to.meta!.scroll = false
    }

    const hashes = to.hash.substring(1).split('&')
    if (to.hash !== '' && hashes.includes(this.modalHash)) {
      this.setModalStateOpen()
    } else {
      this.setModalStateClosed()
    }
  }

  openModal() {
    const currentHash = this.$router.currentRoute.hash
    const hash = (currentHash ? `${currentHash}&` : '') + this.modalHash
    this.$router.push({
      hash,
      query: this.$router.currentRoute.query,
    })
  }

  closeModal() {
    this.$routerClient.getReferrer() ? this.$router.back() : this.applyModal()
  }

  applyModal() {
    const currentHash = this.$router.currentRoute.hash
    const hashes = currentHash.substring(1).split('&')
    this.$router.push({
      hash: hashes.filter((el) => el !== this.modalHash).join('&'),
      query: this.$router.currentRoute.query,
    })
  }

  beforeDestroy() {
    document.body.removeAttribute('data-noscroll')
  }
}
